import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I made a python script that converts SVG to React ?",
  "description": "",
  "published": "2016-11-15T00:00:00.000Z",
  "redirect_from": ["/blog/python-script-svg-react/swizec/7217"],
  "categories": "Front End, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I made a terrible thing Sunday night.`}</p>
    <p>{`The theme that I bought for `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-26-new-page-react-indie-bundle/swizec/7211"
      }}>{`the new React Indie Bundle page`}</a>{` has decorations built with SVG. You slap them into the page as `}<inlineCode parentName="p">{`<svg>`}</inlineCode>{` tags, and it makes your sections look nice.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/11/decorations.png",
        "alt": null
      }}></img></p>
    <p>{`You're supposed to slap them into the page as `}<inlineCode parentName="p">{`<svg>`}</inlineCode>{` tags. It's great that `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{` has built-in support for importing svgs, right?`}</p>
    <p>{`Well… that's meant for images. `}<inlineCode parentName="p">{`import arrow from 'decorations/arrow.svg`}</inlineCode>{` gives you a relative URL. Something like `}<inlineCode parentName="p">{`public/decorations/arrow.svg`}</inlineCode>{` that you're meant to use as a `}<inlineCode parentName="p">{`src`}</inlineCode>{` prop for an image tag.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import arrow from 'decorations/arrow.svg\`

// ...
const Arrow = () => (
    <img src={arrow}>
);
`}</code></pre>
    <p>{`This, of course, does not work with with the Angle theme. That one wants you to use SVG as a first-class citizen of the DOM. So what's a guy to do? ?`}</p>
    <p>{`Well… heh… I built a python script that takes SVG and crudely turns it into a React component. This is a terrible idea, but with a lot of manual massaging, it worked. ?`}</p>
    <h2 {...{
      "id": "here-it-is"
    }}>{`Here it is:`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`import os

# from http://stackoverflow.com/questions/4303492/how-can-i-simplify-this-conversion-from-underscore-to-camelcase-in-python
def dash_to_camelcase(value):
    def camelcase():
        yield str.lower
        while True:
            yield str.capitalize

    c = camelcase()
    return "".join(c.next()(x) if x else '-' for x in value.split("-"))

for subdir, dirs, files in os.walk('./top'):
    for file in files:
        path = os.path.join(subdir, file)
        name, ext = file.split('.')

        with open(path, 'r') as f:
            svg = f.read()

            svg = svg.replace('<svg', 'import React from "react"; export const %s = () => (<svg' % dash_to_camelcase(name), 1) \\
                     .replace('class=', 'className=') \\
                     .replace('preserveaspectratio=', 'preserveAspectRatio=') \\
                     .replace('viewbox=', 'viewBox=') \\
                     .replace('stroke-width=', 'strokeWidth=') \\
                     .replace('', ')')

            with open(os.path.join(subdir, name+'.js'), 'w') as out:
                out.write(svg)
`}</code></pre>
    <p>{`The script traverses a directory and assumes all the files it finds are SVGs. This is the first red flag. Then it reads the SVG as text and performs some search & replace operations:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`<svg`}</inlineCode>{` becomes a React import, and an exported function declaration`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`class`}</inlineCode>{`, `}<inlineCode parentName="li">{`preserveaspectratio`}</inlineCode>{`, `}<inlineCode parentName="li">{`viewbox`}</inlineCode>{`, and `}<inlineCode parentName="li">{`stroke-width`}</inlineCode>{` are fixed to follow React's prop naming rules`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`</svg>`}</inlineCode>{` gets a `}<inlineCode parentName="li">{`)`}</inlineCode>{` to close the function body.`}</li>
    </ul>
    <p>{`This is red flag number 2 through 6, maybe 7. Why? Because this is terrible, and I should feel bad. You can't parse `}<a parentName="p" {...{
        "href": "http://stackoverflow.com/questions/1732348/regex-match-open-tags-except-xhtml-self-contained-tags"
      }}>{`XML with Regex`}</a>{`, which this is a simplified instance of, and `}<em parentName="p">{`for the love of god use a parser like lxml`}</em>{`.`}</p>
    <p>{`Several problems showed up:`}</p>
    <ul>
      <li parentName="ul">{`Some files had two `}<inlineCode parentName="li">{`<svg>`}</inlineCode>{` tags. I had to manually edit them `}<em parentName="li">{`every time I re-ran the script because bugs`}</em>{` ?`}</li>
      <li parentName="ul">{`Some files had typos in their props, like `}<inlineCode parentName="li">{`stroke-width = "`}</inlineCode>{`. This is valid XML, but my "parser" couldn't handle it ➡ manual edits`}</li>
      <li parentName="ul">{`Files with two `}<inlineCode parentName="li">{`<svg>`}</inlineCode>{`s have to be wrapped in a `}<inlineCode parentName="li">{`<div>`}</inlineCode>{` to fulfill React's "one child per component" policy. This needs manual edits because my "parser" knows nothing.`}</li>
    </ul>
    <p>{`2 hours after I started, I was done. Happy to have successfully turned 30 svgs into React components, I could now use the two that I needed. Excellent.`}</p>
    <p>{`Yak shaving at its finest.`}</p>
    <p>{`This could make a useful Webpack plugin, though. Import SVG as a React component? That sounds like something everybody needs ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      